import React from 'react'
import { Routes } from 'react-router-dom'
import useAuthRedirect from 'hooks/useAuthRedirect'
import { renderRoutes } from './routes'
import { routes } from './routes/contants'

const AppRouter: React.FC = () => {
  useAuthRedirect()
  return <Routes>{renderRoutes(routes)}</Routes>
}

export default AppRouter
